import { DateTimeHelper } from '../../../../helper/date-time.helper';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener, Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit, Output, SimpleChanges, TemplateRef, ViewChild, ViewContainerRef
} from '@angular/core';
import { LOCALE_KEY } from '../../../../services/user-service/user-token.service';
import { RecurringDate } from "../../../../models/profile/profile.model";

@Component({
  selector: 'fi-date-time',
  templateUrl: './date-time.component.html',
  styleUrls: ['./date-time.component.scss'],
  standalone: false,
})
export class DateTimeComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() dateToDisplay: Date | string;
  @Input() dateRangeToDisplay: (Date | string)[];
  @Input() withHours = true;
  @Input() noTimePicker = false;
  @Input() enableRecurring = true;
  @Input() absolutePositioning = false;
  @Input() showRangeOptions = false;
  @Input() appointmentExists = false;
  @Input() selectMode: 'single' | 'range' = 'single';
  @Input() profileSpace: HTMLElement;
  @Input() emitUpdateRangeOnlyWhenToggled = true;
  @Input() transparentOverlay = false;
  @Input() showClearButton = false;
  @Input() readonly = false;
  @Input() positionAnchor?: HTMLElement;
  @Input() rangeDateFormat: 'full' | 'short' = 'full';

  @Input()
  absenceRecurring: RecurringDate = {
    RecurringTimeFrom: undefined,
    RecurringTimeTo: undefined,
    RecurringDays: 0,
  };

  @Output() dateSelected = new EventEmitter<Date>();
  @Output() dateRangeSelected = new EventEmitter<Date[]>();
  @Output() selectionChanged = new EventEmitter<Date>();
  @Output() recurringData = new EventEmitter<RecurringDate>();

  @ViewChild('inputField') inputField: ElementRef;
  @ViewChild('times') times: ElementRef;
  @ViewChild('daysContainer') daysContainer: ElementRef;
  @ViewChild('calendar') calendar: TemplateRef<any>;

  private date = '';
  private updateInterval: any = -1;
  private selectingDate2 = false;
  private date1 = new Date();
  private date2 = new Date();

  private updateCounter = 0;
  private updatePeriod = 10;
  private isDate2Touched = false;


  rangeButtons: {key: string; text: string;}[] = [
    {
      text: 'Heuete',
      key: 'TODAY',
    },
    {
      text: 'Gestern',
      key: 'YESTERDAY',
    },
    {
      text: 'Letze Woche',
      key: 'LAST_WEEK',
    },
    {
      text: 'Letzer Monat',
      key: 'LAST_MONTH',
    },
    {
      text: 'Alter als 6 Monate',
      key: 'OLDER_THAN_SIX_MONTHS',
    },
    {
      text: 'Letzes Jahr',
      key: 'LAST_YEAR',
    }
  ]

  rangeButtonIndex = -1;

  formattedDate = '';

  placeholderWithoutHours = 'tt.mm.jjjj';

  isMobile = false;
  recurringTimeFromId = -1;
  recurringTimeToId = -1;
  isDate1Touched = false;

  active = false;
  calendarStyles = {};

  hours: string[] = [];
  minutes = ['00', '15', '30', '45'];

  days: string[] = [];
  weekdayPaddings = [];

  selectedYear = 0;
  selectedMinuteIndex = 0;
  selectedHourIndex = 0;
  selectedMonthIndex = 0;
  selectedDay1Index = -1;
  selectedDay2Index = -1;
  currentDayIndex = -1;
  showAppointmentExists: boolean;
  localLanguage: string;
  showRecurring = false;

  recurringDays = {
    monday: { Id: 1, checked: false, bitMaskCode: 1 },
    tuesday: { Id: 2, checked: false, bitMaskCode: 2 },
    wednesday: { Id: 3, checked: false, bitMaskCode: 4 },
    thursday: { Id: 4, checked: false, bitMaskCode: 8 },
    friday: { Id: 5, checked: false, bitMaskCode: 16 },
    saturday: { Id: 6, checked: false, bitMaskCode: 32 },
    sunday: { Id: 7, checked: false, bitMaskCode: 64 }
  };
  recurringFrom: string;
  recurringTo: string;
  timesFrom = [];
  timesTo = [];

  firstColumn = [];
  secondColumn = [];
  thirdColumn = [];
  fourthColumn = [];
  fifthColumn = [];
  sixthColumn = [];
  emptyFifthColumn = [];
  emptySixthColumn = [];
  toFirstColumnLength: number;
  toSecondColumnLength: number;
  toThirdColumnLength: number;
  toFourthColumnLength: number;
  toFifthColumnLength: number;

  constructor(private viewContainerRef: ViewContainerRef) {
    this.addHours();
  }

  @HostListener('window:resize')
  onResize(): void {
    setTimeout(() => {
      this.updateCalendarSizeAndPosition();
    }, 300);
  }

  @HostListener('window:scroll')
  onScroll(): void {
    this.updateCalendarSizeAndPosition();
  }

  onInputClick(event: MouseEvent): void {
    if (!this.showClearButton) {
      event.stopPropagation();
      this.toggleCalendar();
    } else {
      (document.activeElement as HTMLInputElement)?.blur();
    }
  }

  ngOnInit(): void {
    this.localLanguage = sessionStorage.getItem(LOCALE_KEY);
    this.setSelectedDay();
    this.getDaysForMonth();
    this.setTimes();
  }

  setRange(index: number): void {
    this.isDate1Touched = this.isDate2Touched = true;
    this.selectingDate2 = false;
    this.rangeButtonIndex = index;
    this.date1 = new Date();
    this.date1.setHours(0)
    this.date2 = new Date(this.date1);

    switch (this.rangeButtons[index].key) {
      case 'YESTERDAY':
        this.date1.setDate(this.date1.getDate() - 1);
        this.date2.setDate(this.date2.getDate() - 1);
        break;
      case 'LAST_WEEK':
        this.date1.setDate(this.date1.getDate() - 6 - this.date1.getDay());
        this.date2.setDate(this.date2.getDate() - this.date2.getDay());
        break;
      case 'LAST_MONTH':
        this.date1.setMonth(this.date1.getMonth() - 1, 1);
        this.date2.setDate(0);
        break;
      case 'OLDER_THAN_SIX_MONTHS':
        this.date1.setMonth(this.date1.getMonth() - 6);
        break;
      case 'LAST_YEAR':
        this.date1.setFullYear(this.date1.getFullYear() - 1, 0, 1);
        this.date2.setFullYear(this.date2.getFullYear() - 1, 11, 31);
        break;
    }

    this.setSelectedDay();
    this.getDaysForMonth();
    this.updateInputText();

    if (!this.emitUpdateRangeOnlyWhenToggled) {
      this.dateRangeSelected.emit([this.date1, this.date2])
    }
  }

  ngAfterViewInit(): void {
    const embeddedViewRef = this.viewContainerRef.createEmbeddedView(this.calendar);
    embeddedViewRef.detectChanges();

    for (const node of embeddedViewRef.rootNodes) {
      document.body.appendChild(node);
    }

    this.updateInterval = setInterval(() => {
      if (this.active && (this.updateCounter % this.updatePeriod === 0)) {
        this.updateCalendarSizeAndPosition();
      }

      ++this.updateCounter;
    }, 100);

    if (!this.selectedYear) {
      this.updateInputText();
    }

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.active) {
      if (this.selectMode === 'range' &&
        this.dateRangeToDisplay &&
        this.dateRangeToDisplay[0] &&
        this.dateRangeToDisplay[1]) {
        this.isDate1Touched = this.isDate2Touched = true;
        this.date1 = new Date(this.dateRangeToDisplay[0]);
        this.date2 = new Date(this.dateRangeToDisplay[1]);
        this.setSelectedDay();
        this.getDaysForMonth();
        this.updateInputText();
      } else if (this.dateToDisplay) {
        this.isDate1Touched = true;
        this.date1 = new Date(this.dateToDisplay);
        this.date2 = new Date(this.date1);
        this.setSelectedDay();
        this.getDaysForMonth();
        this.updateInputText();
      } else if (this.selectMode === 'range' && changes.dateRangeToDisplay) {
        this.resetDisplayedRange();
      }
    }

    if (this.selectMode === 'range' && changes.absenceRecurring?.currentValue) {
      for (let weekday in this.recurringDays) {
        if (this.recurringDays[weekday].bitMaskCode & this.absenceRecurring.RecurringDays) {
          this.recurringDays[weekday].checked = true;
        }
      }

      this.recurringFrom = this.absenceRecurring.RecurringTimeFrom?.split(':').slice(0, 2).join(':');
      this.recurringTo = this.absenceRecurring.RecurringTimeTo?.split(':').slice(0, 2).join(':');

      this.updateInputText();

      if (this.absenceRecurring.RecurringTimeFrom || this.absenceRecurring.RecurringTimeTo || this.absenceRecurring.RecurringDays) {
        this.showRecurring = false;
        this.toggleRecurring();
      }
    }
  }

  ngOnDestroy(): void {
    this.viewContainerRef.detach();

    if (this.updateInterval !== -1) {
      clearInterval(this.updateInterval);
    }
  }

  addHours(): void {
    for (let i = 0; i < 24; ++i) {
      this.hours.push((i < 10 ? '0' : '') + i);
    }
  }

  setTimes(): void {
    let id = 0;
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 59; minute += 30) {
        const formattedHour = hour < 10 ? '0' + hour : hour;
        const formattedMinute = minute === 0 ? '00' : minute;
        this.timesFrom.push({ Id: ++id, Time: `${formattedHour}:${formattedMinute}` });
        this.timesTo.push({ Id: ++id, Time: `${formattedHour}:${formattedMinute}` });
      }
    }

    this.recurringTimeFromId = this.timesFrom.find(time => time.Time === this.recurringFrom)?.Id;
    this.recurringTimeToId = this.timesTo.find(time => time.Time === this.recurringTo)?.Id;
  }

  addProfileUserMargin(): void {
    if (!this.profileSpace) {
      return;
    }
    const headerContainer = document.querySelector('.header-container');
    if (this.active) {
      this.profileSpace?.classList.add('calendar-active');
      headerContainer?.classList.add('calendar-open');
    } else {
      this.profileSpace?.classList.remove('calendar-active');
      headerContainer?.classList.remove('calendar-open');
    }
  }

  toggleRecurring(): void {
    this.showRecurring = !this.showRecurring;
    if (this.showRecurring) {
      this.profileSpace?.classList.add('recurring-active');
    } else {
      this.profileSpace?.classList.remove('recurring-active');
    }
  }

  toggleCalendar(event?: MouseEvent): void {
    if (this.readonly) {
      return;
    }

    if (event) {
      const el = document.elementsFromPoint(event.clientX, event.clientY)[1] as HTMLElement;

      setTimeout(() => {
        (el?.closest('.delete-btn') as HTMLElement)?.click();
      })
    }

    this.active = !this.active;
    this.addProfileUserMargin();
    this.updateCalendarSizeAndPosition();
    const input = this.inputField?.nativeElement as HTMLInputElement;
    if (this.checkEmptyInputValue()) {
      return;
    }
    this.updateInputText();

    if (!this.active) {
      if (this.selectMode === 'range') {
        if (this.isDate1Touched) {
          this.dateRangeSelected.emit([this.date1, this.date2]);
        }

        this.emitRecurringDate();
        this.selectingDate2 = false;
      } else {
        this.date1.setHours(this.selectedHourIndex, this.selectedMinuteIndex * 15);
        this.dateSelected.emit(this.date1);
      }

      if (input) {
        input.readOnly = false;
      }
    } else if (this.selectMode !== 'range') {
      setTimeout(() => {
        ((this.daysContainer?.nativeElement as HTMLElement)
          ?.querySelector('button.selected') as HTMLElement)?.blur();
      }, 500);
    }
  }

  emitRecurringDate(): void {
    this.absenceRecurring.RecurringDays = 0;
    this.absenceRecurring.RecurringTimeFrom = this.absenceRecurring.RecurringTimeTo = undefined;

    if (!!this.recurringFrom) {
      this.absenceRecurring.RecurringTimeFrom = this.recurringFrom + ':00';
    }

    if (!!this.recurringTo) {
      this.absenceRecurring.RecurringTimeTo = this.recurringTo + ':00';
    }

    for (let weekday in this.recurringDays) {
      const value = this.recurringDays[weekday];
      if (value.checked) {
        this.absenceRecurring.RecurringDays |= value.bitMaskCode;
      }
    }

    this.recurringData.emit(this.absenceRecurring);
  }

  checkEmptyInputValue(): boolean {
    const input = this.inputField?.nativeElement as HTMLInputElement;
    if (this.selectMode !== 'range') {
      input.blur();
    }

    if (this.selectMode === 'range' && !this.active && !input.value) {

      this.dateRangeSelected.emit([undefined, undefined]);
      if (input) {
        this.formattedDate = this.date;
      }
      return true;
    }
    return false;
  }

  onKeydown(event: KeyboardEvent, isDate: boolean, index: number): void {
    if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.code)) {
      let button = event.currentTarget as HTMLElement;
      if (isDate) {
        button.blur();
      }

      const iterations = (isDate && ['ArrowUp', 'ArrowDown'].includes(event.code)) ? 7 : 1;
      const isNext = ['ArrowRight', 'ArrowDown'].includes(event.code);

      if (!isDate && ['ArrowLeft', 'ArrowRight'].includes(event.code)) {
        button = (isNext ?
          button.parentElement?.nextElementSibling :
          button.parentElement?.previousElementSibling)?.firstElementChild as HTMLElement;
      } else {
        for (let i = 0; i < iterations; ++i) {
          button = (isNext ? button?.nextElementSibling : button?.previousElementSibling) as HTMLElement;
        }
      }

      if (isDate && !(button instanceof HTMLButtonElement)) {
        const date = new Date();
        date.setFullYear(this.selectedYear, this.selectedMonthIndex, index + 1);
        this.getDaysForMonth(isNext ? 'next' : 'previous');

        setTimeout(() => {
          const buttons = (this.daysContainer?.nativeElement as HTMLElement)
            ?.querySelectorAll('button');

          date.setDate(date.getDate() + (isNext ? iterations : -iterations));

          buttons[date.getDate() - 1]?.focus();
        }, 50);
      } else {
        button?.focus();
      }

      event.preventDefault();
    }
  }

  delete(): void {
    this.rangeButtonIndex = -1;
    this.date = '';

    if (this.selectMode === 'single') {
      this.dateSelected.emit(undefined);
    } else {
      this.showRecurring = this.isDate1Touched = this.isDate2Touched = false;

      for (let weekday in this.recurringDays) {
        this.recurringDays[weekday].checked = false;
      }

      this.recurringTimeToId = this.recurringTimeFromId = -1;

      this.absenceRecurring = {
        RecurringTimeFrom: undefined,
        RecurringTimeTo: undefined,
        RecurringDays: 0,
      };

      this.recurringData.emit(this.absenceRecurring);
      this.dateRangeSelected.emit([undefined, undefined]);
    }

    // trigger change
    this.formattedDate = '';
  }

  private resetDisplayedRange(): void {
    this.rangeButtonIndex = -1;
    this.date = '';
    this.showRecurring = false;
    this.selectingDate2 = false;
    this.isDate1Touched = false;
    this.isDate2Touched = false;
    this.formattedDate = '';
    this.date1 = new Date();
    this.date2 = new Date(this.date1);
    this.setSelectedDay();
    this.getDaysForMonth();
  }

  onChange(event): void {
    if (event.inputType === 'deleteContentBackward') {
      this.delete();
    }

    // trigger change
    this.formattedDate += ' ';

    setTimeout(() => {
      this.formattedDate = this.date;
    }, 50);
  }

  onSelectTime(hourIndex: number, minuteIndex: number): void {
    this.selectedHourIndex = hourIndex;
    this.selectedMinuteIndex = minuteIndex;
    this.updateInputText();

  }

  onSelectDate(index: number): void {
    this.rangeButtonIndex = -1;
    const date = new Date();
    date.setHours(12, 0, 0, 0);
    date.setFullYear(this.selectedYear, this.selectedMonthIndex, index + 1);

    this.isDate1Touched = true;

    if (this.selectingDate2) {
      this.date2 = date;
      this.selectedDay2Index = index;
      this.isDate2Touched = true;

      if (this.date2 < this.date1) {
        [this.date1, this.date2] = [this.date2, this.date1];
        [this.selectedDay1Index, this.selectedDay2Index] = [this.selectedDay2Index, this.selectedDay1Index];
      }

      this.getDaysForMonth();
      this.selectingDate2 = false;

      if (!this.emitUpdateRangeOnlyWhenToggled) {
        this.dateRangeSelected.emit([this.date1, this.date2])
      }
    } else {
      this.selectedDay1Index = this.selectedDay2Index = index;
      this.date1 = this.date2 = date;
      this.selectingDate2 = this.selectMode === 'range';
    }

    if (!this.selectingDate2) {
      this.updateInputText();
    }
  }

  getDaysForMonth(month: 'current' | 'next' | 'previous' = 'current'): void {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    date.setFullYear(this.selectedYear, this.selectedMonthIndex, 1);

    if (month === 'next') {
      date.setMonth(date.getMonth() + 1);
    } else if (month === 'previous') {
      date.setMonth(date.getMonth() - 1);
    }

    const monthStart = new Date(date);

    this.selectedMonthIndex = date.getMonth();
    this.selectedYear = date.getFullYear();
    this.weekdayPaddings.length = (date.getDay() + 6) % 7;

    this.days = [];

    while (this.selectedMonthIndex === date.getMonth()) {
      this.days.push(date.getDate() + '');
      date.setDate(date.getDate() + 1);
    }

    if (this.selectMode === 'range') {
      this.sliceDaysToColumn();
      this.fillLastEmptyDays();
    }

    const monthEnd = new Date(date);
    this.handleSelectedDaysIndex(monthStart, monthEnd);
  }

  sliceDaysToColumn(): void {
    const copyDays = [...this.days];

    // 7, 14, 28 - 28 last week days
    this.toFirstColumnLength = 7 - this.weekdayPaddings.length;
    this.toSecondColumnLength = 14 - this.weekdayPaddings.length;
    this.toThirdColumnLength = 21 - this.weekdayPaddings.length;
    this.toFourthColumnLength = 28 - this.weekdayPaddings.length;
    this.toFifthColumnLength = 35 - this.weekdayPaddings.length;

    this.firstColumn = [...copyDays.slice(0, this.toFirstColumnLength)];
    this.secondColumn = [...copyDays.slice(this.toFirstColumnLength, this.toSecondColumnLength)];
    this.thirdColumn = [...copyDays.slice(this.toSecondColumnLength, this.toThirdColumnLength)];
    this.fourthColumn = [...copyDays.slice(this.toThirdColumnLength, this.toFourthColumnLength)];
    this.fifthColumn = [...copyDays.slice(this.toFourthColumnLength, this.toFifthColumnLength)];
    this.sixthColumn = [...copyDays.slice(this.toFifthColumnLength, this.days.length)];
  }

  fillLastEmptyDays(): void {
    const lastWeekDay = 7;
    this.emptyFifthColumn = [];
    this.emptySixthColumn = [];

    if (this.fifthColumn.length < lastWeekDay) {
      this.emptyFifthColumn.length = lastWeekDay - this.fifthColumn.length;
    }

    if (this.sixthColumn.length < lastWeekDay) {
      this.emptySixthColumn.length = lastWeekDay - this.sixthColumn.length;
    }
  }

  handleSelectedDaysIndex(monthStart: Date, monthEnd: Date): void {
    if (this.date1 < monthStart) {
      this.selectedDay1Index = -1;
    } else if (this.date1 >= monthEnd) {
      this.selectedDay1Index = 100;
    } else {
      this.selectedDay1Index = this.date1.getDate() - 1;
    }

    if (this.selectMode === 'range') {
      if (this.date2 < monthStart) {
        this.selectedDay2Index = -1;
      } else if (this.date2 >= monthEnd) {
        this.selectedDay2Index = 100;
      } else {
        this.selectedDay2Index = this.date2.getDate() - 1;
      }
    } else {
      this.selectedDay2Index = -1;
    }

    const today = new Date()

    if (monthStart.getMonth() === today.getMonth() && monthStart.getFullYear() === today.getFullYear()) {
      this.currentDayIndex = today.getDate() - 1;
    } else {
      this.currentDayIndex = -1;
    }
  }

  public updateInputText(): void {
    if (this.selectMode === 'range') {
      this.formattedRangeDate();
    } else {
		if (this.noTimePicker) {
			this.date = this.date1.toLocaleDateString('ro-RO');
		} else {
			this.date = DateTimeHelper
				.getFormattedDate(this.date1.toString(),
				this.selectedHourIndex,
				this.active ? this.selectedMinuteIndex * 15 : undefined);
		}


      if (this.active) {
        if (this.appointmentExists) {
          this.showAppointmentExists = false;
        }
        const dateToEmit = new Date(this.date1);
        dateToEmit.setHours(this.selectedHourIndex, this.selectedMinuteIndex * 15, 0, 0);
        this.selectionChanged.emit(dateToEmit);
      } else {
        this.appointmentExists ? this.showAppointmentExists = true : this.showAppointmentExists = false;
      }
    }
    this.changeInputValue();
  }

  private changeInputValue(): void {
    setTimeout(() => {
      const inputEl = this.inputField?.nativeElement as HTMLInputElement;
      if (inputEl) {
        this.formattedDate = this.date;
      }
    }, 0);
  }

  private formattedRangeDate(): void {
    this.localLanguage = sessionStorage.getItem(LOCALE_KEY);
    let weekDayLabels: string | string[] = [];

    this.placeholderWithoutHours = this.formatRangeDateValue(new Date()) + ' - ...';

    for (let weekday in this.recurringDays) {
      if (this.recurringDays[weekday].checked) {
        weekDayLabels.push('%_WEEK_DAY_' + (this.recurringDays[weekday].Id - 1) + '_SHORT%')
      }
    }

    const dates = this.isDate2Touched
      ? [this.date1, this.date2].map(date => this.formatRangeDateValue(date)).join(' - ')
      : '';

    const from = !!this.recurringFrom ? this.recurringFrom + ' - ' : '';
    const to = !!this.recurringTo ? this.recurringTo : '';

    if (window.innerWidth > 768 || (!dates && !from && !to)) {
      const lastWeekDay = weekDayLabels.length > 1 ? weekDayLabels.pop() : null;
      weekDayLabels = weekDayLabels.join(', ') + (lastWeekDay ? ' %USER_PROFILE_EDIT_HEADLINE_ABSENCE_DATE_TIME_1% ' + lastWeekDay : '');
      weekDayLabels = (dates && weekDayLabels) ? (' - ' + weekDayLabels) : weekDayLabels;
    } else {
      weekDayLabels = '';
    }


    this.date = dates + weekDayLabels + ((from || to) && (dates || weekDayLabels) ? ' %USER_PROFILE_EDIT_HEADLINE_ABSENCE_DATE_TIME_2% ' : '') + from + to;
    this.changeInputValue();
  }

  private formatRangeDateValue(date: Date): string {
    if (this.rangeDateFormat === 'short') {
      return date.toLocaleDateString('de-DE', {
        day: '2-digit',
        month: '2-digit',
      });
    }

    return DateTimeHelper.getFormattedDate(date.toString()).split(' - ')[0].split(', ')[1];
  }

  private setSelectedDay(): void {
    this.selectedYear = this.date1.getFullYear();
    this.selectedMonthIndex = this.date1.getMonth();
    this.selectedDay1Index = this.date1.getDate() - 1;
    this.selectedHourIndex = this.date1.getHours();
    this.selectedMinuteIndex = Math.floor(this.date1.getMinutes() / 15);
    this.date1.setHours(12, this.selectMode === 'range' ? 0 : this.date1.getMinutes(), 0, 0);
    this.date2.setHours(12, 0, 0, 0);

    setTimeout(() => {
      if (this.selectMode === 'single') {
        this.times?.nativeElement?.querySelector('.selected')?.scrollIntoView();
      }
    }, 100);
  }

  private updateCalendarSizeAndPosition(): void {
    this.isMobile = window.innerWidth <= 880;

    if (this.inputField?.nativeElement) {
      if (this.selectMode === 'range') {
        this.updateInputText();
      }

      this.calendarStyles = this.getCalendarStyles();
    }

  }

  getCalendarStyles(): CalendarStyle {
    const isMobileRangeCalendar = this.selectMode === 'range' && this.showRangeOptions && window.innerWidth <= 880;
    const rect = (isMobileRangeCalendar && this.positionAnchor
      ? this.positionAnchor
      : this.inputField.nativeElement as HTMLElement
    ).getBoundingClientRect();
    const calendarNormalWidth = this.selectMode === 'range' ? rect.width : (this.noTimePicker ? 400 : 550);
    let scale = rect.width / calendarNormalWidth;

    if (scale < 0.632 && window.innerWidth <= 880 && window.innerWidth >= 360) {
      scale = 0.632;
    }

    const padding = rect.height / scale;
    let rectTop = rect.top;
    let rectLeft = rect.left;

    if (rectTop < 0 && this.selectMode === 'single') {
      rectTop = rect.top * -1;
      rectTop += 100;
    }

    if (rectLeft < 0 && !this.showRangeOptions) {
      rectLeft = rect.top * -1;
    }

    if (this.absolutePositioning) {
      rectTop += window.scrollY;
    }

    if (isMobileRangeCalendar) {
      const mobileCalendarWidth = 600;
      const mobileScale = 0.6;
      const scaledWidth = mobileCalendarWidth * mobileScale;
      const minLeft = 15;
      const maxLeft = window.innerWidth - scaledWidth - minLeft;
      const left = Math.max(minLeft, Math.min(rectLeft, maxLeft));

      return {
        transform: `scale(${mobileScale})`,
        top: rect.bottom + 'px',
        bottom: '',
        left: left + 'px',
        transformOrigin: 'left top',
        width: mobileCalendarWidth + 'px',
        paddingBottom: '',
      };
    }

    return this.selectMode === 'single' ? {
      transform: `scale(${scale})`,
      top: rectTop + 'px',
      bottom: '',
      left: rectLeft + 'px',
      transformOrigin: 'left top',
      width: calendarNormalWidth + 'px',
      paddingTop: padding + 'px',
      paddingBottom: '',
    } : {
      transform: (this.showRangeOptions && window.innerWidth <= 880) ? `scale(${rect.width / 618})` : '',
      top: rectTop + 50 + 'px',
      bottom: '',
      left: rectLeft + 'px',
      transformOrigin: 'left top',
      width: ((this.showRangeOptions && window.innerWidth <= 880) ? 618 : calendarNormalWidth) + 'px',
      // paddingTop: ((this.showRangeOptions && window.innerWidth <= 880) ? (rect.height * 618 / rect.width) : padding) + 'px',
      paddingBottom: '',
    };
  }

  setRecurringFrom(id: number): void {
    this.recurringFrom = this.timesFrom.find(field => field.Id === id).Time;
    this.formattedRangeDate();
  }

  setRecurringTo(id: number): void {
    this.recurringTo = this.timesTo.find(field => field.Id === id).Time;
    this.formattedRangeDate();
  }
}

interface CalendarStyle {
  transform: string;
  top: string;
  bottom: '';
  left:  string;
  transformOrigin: string;
  width: string;
  paddingTop?: string;
  paddingBottom: string;
}
